export default __webpack_public_path__ + "static/media/modern.7605bb2f.webp";